module.exports = __webpack_public_path__ + "static/media/400104_02.5bcccf58.png";